module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ComponentForm', {
    attrs: {
      "label": _vm.trads.editHead,
      "loading": _vm.loading || _vm.saving,
      "data": _vm.component
    },
    on: {
      "save": _vm.save,
      "goBack": _vm.goBack,
      "reset": _vm.reset
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-036245ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/edit-component.vue
// module id = 2985
// module chunks = 0